
import { Swiper, SwiperSlide } from "swiper/react";
import { Rating } from "react-simple-star-rating";
import { Link } from "react-router-dom";



const GarageModal = (props) => {




  const { data, addressHandler } = props;
  return (
    <div className="garageModal">
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        onSlideChange={(e) => {
          addressHandler(
            data[e.activeIndex].latitude,
            data[e.activeIndex].longitude
          );
        }}
      >
        {data.map((garage, index) => (
          <SwiperSlide key={index} className="garageSlide">
            <Link
              to={`services/serviceItemDetails?${garage.id}`}
              className="garageLink"
            >
              <img src={garage.image} />
              <div>
                <div className="garageTitle">
                  <span className="garageName ">{garage.name}</span>
                  <Rating
                    ratingValue={garage.rate * 20}
                    readonly={false}
                    style={{ width: "100%" }}
                    size={15}
                    rtl
                    fillColor="#F7A600"
                    SVGstorkeWidth={1}
                    className="garageMapRating"
                  />
                </div>
                <div className="garageInfo">
                  <i className="icon-screwdriver-wrench" />
                  <span>
                    {garage.type === "both"
                      ? "خدمات سیار و ثابت"
                      : garage.type === "static"
                      ? "خدمات ثابت"
                      : "خدمات سیار"}
                  </span>
                </div>
                <div className="garageInfo">
                  <i className="icon-cog" />
                  <span>{garage.details}</span>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>

    // <div
    //   className={`garageModal `}
    // >
    //   <img src={data.image} />
    //   <div>
    //     <span className="garageName ">{data.name}</span>
    //     <span>
    //       {data.type === "both"
    //         ? "خدمات سیار و ثابت"
    //         : data.type === "static"
    //         ? "خدمات ثابت"
    //         : "خدمات سیار"}
    //     </span>
    //     <span>{data.details}</span>
    //   </div>
    //   {/* <Link className="showGarage" to={`/serviceItemDetails?${data.id}`}><i className="icon-chevron-left"/></Link> */}
    // </div>
  );
};

export default GarageModal;
